import { services } from "./shared";

// Footer data structure
export interface FooterLink {
  label: string;
  href: string;
}

export interface FooterSection {
  title: string;
  displayName: string;
  href: string;
  links: FooterLink[] | string[];
  type?: "queryParams" | "pathParams";
}

export interface SocialLink {
  label: string;
  href: string;
  icon: string;
  hoverIcon?: string;
}

export interface ContactInfo {
  address: string;
  phones: string[];
}

export interface FooterData {
  sections: FooterSection[];
  socialLinks: SocialLink[];
  contactInfo: ContactInfo;
  companyLogo: {
    src: string;
    alt: string;
    width: number;
    height: number;
    href: string;
  };
  backgroundImage: {
    src: string;
    alt: string;
  };
  copyright: string;
}

// Footer content data - centralized configuration for easy updates

// Social media icons
const socialIcons = {
  facebook: "/icons/facebook.svg",
  linkedin: "/icons/linkedin.svg",
  youtube: "/icons/youtube.svg",
  x: "/icons/x.svg",
};

// Hover icons for social media (colored versions)
const socialHoverIcons = {
  facebook: "/icons/facebook-hover.svg",
  linkedin: "/icons/linkedin-hover.svg",
  youtube: "/icons/youtube-hover.svg",
  x: "/icons/x-hover.svg",
};

// Footer content data
export const footerData: FooterData = {
  sections: [
    {
      title: "About",
      displayName: "About",
      href: "/about",
      links: [
        { label: "Profile", href: "#company-profile" },
        { label: "Philosophy", href: "#philosophy" },
        { label: "Vision", href: "#mission-vision" },
        { label: "Certification", href: "#certification" },
      ],
    },
    {
      title: "News",
      displayName: "News",
      href: "/news",
      links: ["All News", "Business", "Article", "Event & Media", "Others"],
      type: "queryParams",
    },
    {
      title: "Services",
      displayName: "Services",
      href: "/services",
      links: services,
      type: "pathParams",
    },
    {
      title: "Projects",
      displayName: "Projects",
      href: "/projects",
      links: ["Ongoing Projects", "Completed Projects"],
      type: "queryParams",
    },
    {
      title: "Sustainability",
      displayName: "Sustainability",
      href: "/sustainability",
      links: ["Environment", "Social", "Governance"],
      type: "pathParams",
    },
    {
      title: "Contact",
      displayName: "Contact",
      href: "/contact",
      links: [
        { label: "Inquiry", href: "#inquiries" },
        { label: "FAQ", href: "#faq" },
      ],
    },
    {
      title: "Career",
      displayName: "Career",
      href: "/career",
      links: [
        { label: "Life At NKB", href: "#life-at-nippon-koei" },
        { label: "Current Openings", href: "#current-openings" },
      ],
    },
    {
      title: "Legal",
      displayName: "Legal",
      href: "/legal",
      links: [
        { label: "Privacy Policy", href: "/privacy-policy" },
        { label: "Terms & Conditions", href: "/terms-and-conditions" },
      ],
    },
  ],

  socialLinks: [
    {
      label: "LinkedIn",
      href: "https://www.linkedin.com/company/nkbangladesh",
      icon: socialIcons.linkedin,
      hoverIcon: socialHoverIcons.linkedin,
    },
  ],

  contactInfo: {
    address:
      "Concord Baksh Tower, Unit 5-A (5th Floor), Plot # 11-A, Road # 48, Block # CWN (A), Gulshan-2, Dhaka-1212, Bangladesh",
    phones: ["+880 2 2222 95390", "+880 2 2222 95391"],
  },

  companyLogo: {
    src: "/images/site_logo.png",
    alt: "ID&E - A member of Tokyo Marine Group",
    width: 100,
    height: 37,
    href: "https://www.id-and-e-hd.co.jp/english/",
  },

  backgroundImage: {
    src: "/images/footer-bg.png",
    alt: "",
  },

  copyright: "Copyright 2021 Nippon Koei Bangladesh Ltd. All Right Reserved",
};

export function getFooterData(locale: string = "en"): FooterData {
  return footerData;
}
